<template lang="">
  <div>
    <router-view></router-view>
    <content-footer></content-footer>
  </div>
</template>
<script>
import ContentFooter from "./ContentFooter.vue";

export default {
  name: "BlankPage",
  components: {
    ContentFooter,
  },
};
</script>
<style lang=""></style>
